import request from '@/utils/request'

export default {
  initDict (vue, callback) {
    // 请求角色数据
    request.get('/api/dict/all').then(res => {
      vue.$store.statedicts = res.data.data
      if (callback) callback()
    })
  },
  getValue (vue, key, code) {
    if (code) {
      let dicts = null
      try {
        dicts = vue.$store.statedicts
      } catch (e) {
        // 使用表格的scope访问时
        dicts = vue._self.$store.statedicts
      }
      if (dicts) {
        for (let i = 0; i < dicts.length; i++) {
          if (dicts[i].dictKey == key && dicts[i].dictCode == code) {
            return dicts[i].dictValue
          }
        }
      }
    }
    return '--'
  },
  getDicts (vue, key) {
    const dicts = vue.$store.statedicts
    const array = []
    if (dicts) {
      for (let i = 0; i < dicts.length; i++) {
        if (dicts[i].dictKey == key) {
          array.push(dicts[i])
        }
      }
    }
    return array
  }
}
